module.exports = __webpack_public_path__ + "img/login-portada.95d98e70.png";